import {
  Twitter,
  Linkedin,
  Youtube,
} from "lucide-react";
import { Link } from "react-router-dom";
import { ASSET_PATHS } from "./assets";
import { all_links } from "./links";

const socialLinks = [
  { id: 1, Icon: Twitter, url: "https://twitter.com/yourhandle" },
  // { id: 2, Icon: Facebook, url: "https://facebook.com/yourpage" },
  // { id: 3, Icon: Instagram, url: "https://instagram.com/yourprofile" },
  { id: 4, Icon: Linkedin, url: "https://linkedin.com/company/yourcompany" },
  { id: 5, Icon: Youtube, url: "https://youtube.com/yourchannel" },
];
export const Footer = () => (
  <footer className="bg-black text-white pt-8 pb-8">
    <div className="container mx-auto px-4 sm:px-8 md:px-16">
      {/* Main Flex Container: Stacks on mobile, row on desktop */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-start md:gap-12 lg:gap-24">

        {/* --- Left Logo --- */}
        {/* We control its size directly and prevent it from shrinking. */}
        <div className="flex-shrink-0 mb-10 md:mb-0 flex justify-center md:justify-start">
          <img
            src={ASSET_PATHS.sonicImage}
            alt="Company Logo"
            className="w-48 md:w-56 lg:w-64 transform scale-x-[-1]" // Controlled, responsive width
          />
        </div>

        {/* --- Footer Menu Sections --- */}
        {/* This part will grow to fill the available space. */}
        <div className="w-full flex-grow grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">

          {/* Column 1 with right glowing divider */}
          <div className="flex flex-col relative md:after:content-[''] md:after:absolute md:after:top-0 md:after:right-4 md:after:h-full md:after:w-[1px] md:after:bg-gradient-to-b md:after:from-transparent md:after:via-white/30 md:after:to-transparent">
            <h3 className="text-2xl font-pixel mb-3">PRODUCTS</h3>
            <div className="h-[1px] bg-gradient-to-r from-transparent via-white/50 to-transparent mb-4"></div>
            <ul className="space-y-3 font-kodeMono text-lg">
              <li>
                <a href={all_links.docs.recaptcha} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  ReCaptcha
                </a>
              </li>
              <li>
                <a href={all_links.docs.PopularCaptcha} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  Popular Captcha
                </a>
              </li>
              <li>
                <a href={all_links.docs.GeeTestCaptcha} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  GeeTest Captcha
                </a>
              </li>
              <li>
                <a href={all_links.docs.Awswaf} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  Awswaf
                </a>
              </li>
              <li>
                <a href={all_links.docs.Bls} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  BLS OCR Captcha
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2 with right glowing divider */}
          <div className="flex flex-col relative md:after:content-[''] md:after:absolute md:after:top-0 md:after:right-4 md:after:h-full md:after:w-[1px] md:after:bg-gradient-to-b md:after:from-transparent md:after:via-white/30 md:after:to-transparent">
            <h3 className="text-2xl font-pixel mb-3">COMPANY</h3>
            <div className="h-[1px] bg-gradient-to-r from-transparent via-white/50 to-transparent mb-4"></div>
            <ul className="space-y-3 font-kodeMono text-lg">
              <li><Link to="/about" className="hover:text-cyan-300 transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-cyan-300 transition-colors">Contact Us</Link></li>
              <li><Link to="/terms" className="hover:text-cyan-300 transition-colors">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-cyan-300 transition-colors">Privacy</Link></li>
              <li><Link to="/refunds" className="hover:text-cyan-300 transition-colors">Refunds</Link></li>
              <li><Link to="/faq" className="hover:text-cyan-300 transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Column 2 with right glowing divider */}
          <div className="flex flex-col relative md:after:content-[''] md:after:absolute md:after:top-0 md:after:right-4 md:after:h-full md:after:w-[1px] md:after:bg-gradient-to-b md:after:from-transparent md:after:via-white/30 md:after:to-transparent">
            <h3 className="text-2xl font-pixel mb-3">Resources</h3>
            <div className="h-[1px] bg-gradient-to-r from-transparent via-white/50 to-transparent mb-4"></div>
            <ul className="space-y-3 font-kodeMono text-lg">
              <li><Link to="https://status.captchasonic.com/" className="hover:text-cyan-300 transition-colors">Service Status</Link></li>
              <li><Link to="https://docs.captchasonic.com/api/" className="hover:text-cyan-300 transition-colors">API Reference</Link></li>
              <li><Link to="https://captchasonic.com/changes" className="hover:text-cyan-300 transition-colors">Changelogs</Link></li>
              <li><Link to="https://docs.captchasonic.com/blog/" className="hover:text-cyan-300 transition-colors">Blogs</Link></li>
              <li><Link to="https://docs.captchasonic.com/guides/addfunds/" className="hover:text-cyan-300 transition-colors">Guides</Link></li>
              <li><Link to="/presskit" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">Press Kit</Link></li>
              <li><Link to="/partner" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">Partner</Link></li>
            </ul>
          </div>

          {/* Column 3 - no divider */}
          <div className="flex flex-col">
            <h3 className="text-2xl font-pixel mb-3">Extension Download</h3>
            <div className="h-[1px] bg-gradient-to-r from-transparent via-white/50 to-transparent mb-4"></div>
            <ul className="space-y-3 font-kodeMono text-lg">

              <li>
                <a href={all_links.all.chrome_extension} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  Captcha Chrome Extension
                </a>
              </li>
              <li>
                <a href={all_links.all.firefox_extension} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  Captcha Firefox Addon
                </a>
              </li>
              <li>
                <a href={all_links.all.zip} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  Download Zip
                </a>
              </li>
              <li className="pt-5 border-t border-t-gray-700 ">
                <a href={all_links.bls.chrome_store} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  BLS Chrome Extension
                </a>
              </li>
              <li>
                <a href={all_links.bls.firefox_Store} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  BLS Firefox Addon
                </a>
              </li>
              <li>
                <a href={all_links.bls.zip_store} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 transition-colors">
                  BLS Zip Download
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Full-width footer logo */}
      <div className="mt-12 w-full px-4 sm:px-0 mx-auto flex justify-center items-center">
        <img
          className="w-full max-w-2xl" // Use max-width for better control
          src={ASSET_PATHS.footer}
          alt="Footer Logo"
        />
      </div>

      {/* Divider and bottom section */}
      <div className="mt-8">
        <div className="h-[1px] bg-gradient-to-r from-gray-800 via-gray-600 to-gray-800"></div>
        <div className="flex flex-col md:flex-row justify-between items-center pt-6 gap-6">
          <div className="text-xl font-mono font-bold text-gray-400 text-center md:text-left">
            © CaptchaSonic.com
          </div>
          <div className="flex space-x-4">
            {socialLinks.map(({ id, Icon, url }) => (
              <a
                key={id}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-70 hover:opacity-100 transition-opacity"
              >
                <Icon className="h-7 w-7 text-white" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  </footer>
);